module.exports = __webpack_public_path__ + "img/09.aafc07ac.jpg";